import { cargoTypeConstants } from '../../_constants';

export function cargoTypes(state = {}, action) {
    switch (action.type) {
        case cargoTypeConstants.CARGO_TYPE_FETCHING:
            return {
                ...state,
                cargoTypeFetching: true
            };
        case cargoTypeConstants.CARGO_TYPE_FETCHED:
            return {
                ...state,
                cargoTypeFetching: false
            };
        case cargoTypeConstants.CARGO_TYPE_SUBMITTING:
            return {
                ...state,
                cargoTypeSubmitting: true
            };
        case cargoTypeConstants.CARGO_TYPE_SUBMITTED:
            return {
                ...state,
                cargoTypeSubmitted: false
            };
        case cargoTypeConstants.GET_CARGO_TYPES:
            return {
                ...state,
                cargoTypes: action.cargoTypes
            };
        case cargoTypeConstants.GET_CARGO_TYPE_BY_ID:
            return {
                ...state,
                cargoType: action.cargoType
            };
        case cargoTypeConstants.GET_ACTIVE_CARGO_TYPES:
            return {
                ...state,
                activeCargoTypes: action.activeCargoTypes
            };
        default:
            return state;
    }
}